import React from 'react';

import { DashboardFiltersContextProvider } from '../components/filters/DashboardFiltersContext';
import DashboardLandingContent from './DashboardLandingContent';

const DashboardLandingPage = () => <DashboardFiltersContextProvider><DashboardLandingContent /></DashboardFiltersContextProvider>

export default DashboardLandingPage;
